import axios from "axios";
import {Pallet} from "@/api/pallet";


export interface Product {
  id: string | null;
  title: string;
  description: string | null;
  onsale: boolean;

  weightInKg: number | null;

  possiblePallet?: Pallet | null;
}

interface ProductApi {
  list(): Promise<Product[]>;
  add(product: Product): Promise<string>;
  edit(product: Product): Promise<void>;
  delete(product: Product): Promise<void>;
}

export const productApi: ProductApi = {
  async list() {
    return (await axios.get("/api/products")).data;
  },

  async edit(product) {
    return await axios.put(`/api/products/${product.id}`, product);
  },

  async add(product) {
    return (await axios.post("/api/products", product)).data;
  },

  async delete(product) {
    return await axios.delete(`/api/products/${product.id}`);
  },
};
